import ViewsLoader from '../../../components/loader/ViewsLoader'

const DataTableLoader = () => <ViewsLoader className="my-20" size="lg" color="red" />

export default DataTableLoader
